import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../models/user';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { LoggingService } from './logging.service';

export interface MonthlyOverview {
  month: string;
  totalScore: number;
}

@Injectable({
  providedIn: 'root'
})
export class HrDashboardService {

  constructor(private httpClient : HttpClient, private apiService: ApiService,
              private loggingService : LoggingService) { }

  getAllHrDetails(userId : number, userRole : string) : Observable<User> {
      const params = {
        userId : userId,
        personType : userRole
      };
      this.loggingService.logDebug("Retrieving user details based on user id "+ userId +" and user role "+ userRole);
      return this.httpClient.get<User>(this.apiService.getUrl('user/hrDetails'), {params : params});
  }
   
   getMonthlyOverview(entityType: string, entityId: number): Observable<MonthlyOverview[]> {
    this.loggingService.logDebug(
      `Fetching monthly overview for ${entityType} with ID ${entityId}`
    );
    return this.httpClient.get<MonthlyOverview[]>(
      this.apiService.getUrl(`hr-dashboard/monthly-overview/${entityType}/${entityId}`)
    );
  }

  getEntityPulseScore(entityType: string, entityId: number): Observable<any> {
    this.loggingService.logDebug(`Fetching pulse score for ${entityType} with ID = ${entityId}`);
    return this.httpClient.get(
      this.apiService.getUrl(`hr-dashboard/aggregated-score/${entityType}/${entityId}`)
    );
  }
  
  getCriticalTeams(entityId: number): Observable<any> {
    this.loggingService.logDebug(`Fetching critical teams for tenantId = ${entityId}`);

    return this.httpClient.get(
      this.apiService.getUrl(`hr-dashboard/aggregated-score/org/${entityId}/critical-teams`)
    );
  }

  getHierarchy(tenantId: number): Observable<any> {
    return this.httpClient.get(
      this.apiService.getUrl(`hr-dashboard/${tenantId}/hierarchy`)
    );
  }

  getUserDetails(userId: number): Observable<any> {
  this.loggingService.logDebug(`Fetching details for user ID = ${userId}`);
  return this.httpClient.get(
    this.apiService.getUrl(`hr-dashboard/user/${userId}/details`)
  );
}


}
